"use strict";

exports.__esModule = true;
exports.AdBreakEventHandler = void 0;
var _XmlValidation2 = require("../Parsers/XmlValidation");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/**
 * AdBreakEventHandler declares a set of methods that allow clients to provide event information to an ad break.
 *
 * It is implemented by AdBreak and clients <b>must</b> call each method at the appropriate time so that
 * the SDK can signal analytics on behalf of the app.
 * @hideconstructor
 */
var AdBreakEventHandler = /*#__PURE__*/function (_XmlValidation) {
  _inheritsLoose(AdBreakEventHandler, _XmlValidation);
  function AdBreakEventHandler() {
    return _XmlValidation.apply(this, arguments) || this;
  }
  var _proto = AdBreakEventHandler.prototype;
  /** Indicates that a tracking event occurred for a non-linear ad break. The SDK fires beacons for any `<Tracking>` URLs defined for the ad break.<br/>
   * Clients should call this method in order to fire the appropriate tracking beacons, which may be `breakStart` or `breakEnd`.
   *
   * <b>NOTE:</b> `error` event is not supported.
   *
   * <b>NOTE:</b> Clients should call this method only for nonlinear ad breaks. Calling this method on a linear adbreak has no effect.
   * @param {string} event the tracking event
   */
  _proto.onNonLinearTrackingEvent = function onNonLinearTrackingEvent(event) {
    throw new Error("Function must be overridden");
  };
  return AdBreakEventHandler;
}(_XmlValidation2.XmlValidation);
exports.AdBreakEventHandler = AdBreakEventHandler;